export const billingAndShippingAddress = {
    firstName: '',
    lastName: '',
    email: '',
    mobilePhoneNumber: '',
    comment: '',
    deliveryAddress: {
        line1: '',
        line2: '',
        postalCode: '',
        city: '',
        country: {},
    },
    fullName() {
        return `${this.firstName} ${this.lastName}`;
    },
    getSummary() {
        if (this.firstName !== '' && this.lastName !== '' && this.deliveryAddress.line1 !== '' && this.deliveryAddress.postalCode !== '' && this.deliveryAddress.city !== '') {
            return `${this.firstName} ${this.lastName}, ${this.deliveryAddress.line1}, ${this.deliveryAddress.postalCode}, ${this.deliveryAddress.city}`;
        }
        else {
            return '';
        }
    },
    billingAndShippingAddressInit(initUser, initCountries) {
        this.firstName = initUser.firstName;
        this.lastName = initUser.lastName;
        this.mobilePhoneNumber = initUser.mobilePhoneNumber;
        this.email = initUser.email;
        this.deliveryAddress = {
            ...initUser.deliveryAddress,
            country: initCountries.find(x => x.id === initUser.deliveryAddress.countryId)
        };
    }
};
